import { onArtistRiderActivity } from "common/signalR";
import ActivityPanel from "components/ActivityPanel/ActivityPanel";
import React from "react";
import { ArtistRiderActivityCard } from "./ArtistRiderActivityCard";

interface Props {
  artistRiderId: number
  fileId: string
  config: server.dto.ActivityPanelConfig
}

export const ArtistRiderActivityPanel = (props: Props) => {
  const [fileId, setFileId] = React.useState<string>(props.fileId);

  return <ActivityPanel<server.dto.ArtistRiderActivity>
    config={props.config}
    fetchActivities={(page, perPage) => window.CoreApi.ArtistRider.ListActivity({ itemId: props.artistRiderId, page, perPage })}
    renderActivity={(activity => <ArtistRiderActivityCard
      currentFileId={fileId}
      setCurrentFileId={setFileId}
      key={activity.activityId}
      activity={activity}
    />)}
    onActivityRegisterFn={onArtistRiderActivity}
    onActivity={(activity) => {
      if (activity.action.value === "uploadedNewFile") {
        setFileId(activity.fileId);
      }

      if (activity.itemId !== props.artistRiderId) return { refreshActivities: false };

      const iAmActor = (activity.actor?.userId === site.currentUser.userId);

      return { refreshActivities: iAmActor };
    }}
  />
}